var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name],attrs:{"id":`${_vm.cms.scroll_id}`}},[_c('grid',{class:['grid--container', `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: '1fr',
        gap: '6px',
      },
      {
        size: 2,
        columns: '1fr',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:`${_vm.name}__grid-item`,attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 24 },
      ]}},[(!_vm.loadError)?_c('div',[_c('a-copy',{attrs:{"cms":{
            heading: _vm.jobTitle,
            heading_size: 'h3',
            copy: _vm.jobDescription,
          }}}),_vm._v(" "),(_vm.jobDescription.length > 1)?_c('a-cta-v2',{attrs:{"cms":{
            copy: 'Apply',
            type: 'primary',
            href: { url: _vm.jobHref },
          }}}):_vm._e()],1):_c('div',[_c('a-copy',{attrs:{"cms":{
            copy: _vm.jobIDError ? _vm.cms.copy_id_error : _vm.cms.copy_load_error,
          }}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }